import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import "./components/buttons/LinkButtons.css";
import "./branding/current/branding.css";

import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import promiseFinally from "promise.prototype.finally";
import { ConnectedRouter } from "connected-react-router";
import { createHashHistory } from "history";

import store from "./store";
import App from "./App";
import { bootApplication } from "./actions/configActions";
import version from "./version";
import "./misc/accessibilityChecks";
import "./misc/logHijack";
import "./misc/ieFix";
import "./misc/bootstrapFix";
import "./misc/putCursorAtEnd";

import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

promiseFinally.shim();

console.log(version);

var history = createHashHistory();

Sentry.init({
  dsn: "https://3c9237dda7884abeb0acd1e19bdfe219@sentry.nwise.se/2",
  release: `mmx-web-tc@${version}`,
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.reactRouterV4Instrumentation(history),
    }),
  ],
  normalizeDepth: 5,
  tracesSampleRate: 1.0,
  beforeBreadcrumb(breadcrumb, hint) {
    return breadcrumb.category === "console" ? null : breadcrumb;
  },
});

store.dispatch(bootApplication());

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js